import '../node_modules/remixicon/fonts/remixicon.css'
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import 'bootstrap' 

import $ from 'jquery'

/* - - - */

miniToastr.init();
Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')

/* Check to add analytics data */
let url_string = window.location.href;
let url = new URL(url_string);

let analytics_json = {}; 
axios.get(process.env.VUE_APP_ENDPOINT_URL +"/config/analytics.json").then(response => {  
  analytics_json = response.data;  
}).catch(err => { 
  console.error(err);
});

let tenant = url.searchParams.get("tenant"); 
let analytics_data = analytics_json[tenant];
if(analytics_data !== undefined){ 
  if(analytics_data.analytics){
    let js_content = "<!-- Google tag (gtag.js) -->\n"+
                      "<script async src='https://www.googletagmanager.com/gtag/js?id="+ analytics_data.id_tag +"'></script>\n"+
                      "<script>\n"+
                      "  window.dataLayer = window.dataLayer || [];\n"+
                      "  function gtag(){dataLayer.push(arguments);}\n"+
                      "  gtag('js', new Date());\n"+
                      "  gtag('config', '"+ analytics_data.id_tag +"');\n"+
                      "</script>";

    $(js_content).insertBefore("body noscript");
  }
}